import styles from './index.module.scss';
const options = ['Mainland', 'Free Zone', 'Offshore', 'Not Sure'];
export default function BusinessDetails({data, onChange}) {
    return (
        <div className={styles.container}>
            <h2>Tell us about your company</h2>
            <p>Help us to provide you the best option</p>
            <div className={styles.options}>
                {
                    options.map((option, index) => (
                        <label key={index} className={`${styles.option} ${data.jurisdiction === option ? styles.checked : ''}`}>
                            <input
                                type="radio"
                                id={option}
                                name="jurisdiction"
                                value={option}
                                checked={data.jurisdiction === option}
                                onChange={() => onChange('jurisdiction', option)}
                            />
                            {option}
                        </label>
                    ))
                }
            </div>
        </div>
    )
}